module.exports = __webpack_public_path__ + "img/best-price.a5a058a6.png";